'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _dates = require('../../utils/dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATE = [];

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type && action.type.substring(action.type.length - 4) === 'FAIL') {
        var timestamp = Date.now();
        var date = (0, _dates.errorDate)(timestamp);
        var error = (0, _extends3.default)({}, action, {
            date: date,
            timestamp: timestamp
        });

        return [].concat((0, _toConsumableArray3.default)(state), [error]);
    }

    return state;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/errors.js
// module id = frA2
// module chunks = 57